import { log } from '@/logger/logger.ts';
import { getAxiosInstance } from '@/services/axiosConfig';
import { httpReq } from '@/utils/api.utils';
import type {
  CreateSubflowTemplateRequestDto,
  EditSubflowTemplateRequestDto,
  ListSubflowTemplatesResponseDto,
  SubflowTemplateResponseDto,
  SubflowTemplateType,
} from '@/types/api/subflowTemplate';

const logger = log.getLogger('subflowTemplates');
const axiosInstance = getAxiosInstance();

const BASE_PATH = '/v1/subflow-templates';

export const listSubflowTemplates = async (type?: SubflowTemplateType): Promise<SubflowTemplateResponseDto[]> => {
  try {
    const response = await axiosInstance.get<ListSubflowTemplatesResponseDto>(BASE_PATH, {
      ...(type && { params: { type } }),
    });
    return response.data.workspaceSubflowTemplates;
  } catch (error) {
    logger.error('Error listing subflow templates:', error);
    throw error;
  }
};

export const getSubflowTemplate = async (id: string): Promise<SubflowTemplateResponseDto> =>
  httpReq<void, SubflowTemplateResponseDto>(`${BASE_PATH}/${id}`, undefined, 'get');

export const createSubflowTemplate = async (
  dto: CreateSubflowTemplateRequestDto,
): Promise<SubflowTemplateResponseDto> =>
  httpReq<CreateSubflowTemplateRequestDto, SubflowTemplateResponseDto>(BASE_PATH, dto);

export const editSubflowTemplate = async (
  id: string,
  dto: EditSubflowTemplateRequestDto,
): Promise<SubflowTemplateResponseDto> =>
  httpReq<EditSubflowTemplateRequestDto, SubflowTemplateResponseDto>(`${BASE_PATH}/${id}`, dto, 'patch');

export const deleteSubflowTemplate = async (id: string): Promise<void> =>
  httpReq<void, void>(`${BASE_PATH}/${id}`, undefined, 'delete');
